import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";

import { ConsultantSearchEffects } from "../effects/consultant-search.effects";
import { ProfileDownloadEffects } from "../effects/profile-download.effects";
import { ViewProfileEffects } from "../effects/view-profile.effects";
import { IndustryEffects } from "../../industry/effects/industry.effects";
import {
  reducer,
  consultantSearchFeatureKey,
} from "../reducers/consultant-search.reducer";

@NgModule({
  imports: [
    StoreModule.forFeature(consultantSearchFeatureKey, reducer),
    EffectsModule.forFeature([
      ConsultantSearchEffects,
      ProfileDownloadEffects,
      ViewProfileEffects,
      IndustryEffects,
    ]),
  ],
})
export class ConsultantSearchStateModule {}
